import { Sprout, Target, TrendingUp, Zap } from 'lucide-react';
import type { ApplicantTier } from '../types/applicant';

export const applicantTiers: ApplicantTier[] = [
  {
    id: 'emerging',
    level: 1,
    name: 'Emerging',
    minScore: 0,
    summary: 'Early-stage profile with limited track record.',
    reviewPath: 'Waitlisted — reconsidered in 6 months',
    entryTier: 'Not yet eligible',
    icon: Sprout,
  },
  {
    id: 'promising',
    level: 2,
    name: 'Promising',
    minScore: 55,
    summary: 'Solid background, needs more evidence or references.',
    reviewPath: 'Standard review — up to 3 weeks',
    entryTier: 'Enters as Associate',
    icon: TrendingUp,
  },
  {
    id: 'strong',
    level: 3,
    name: 'Strong',
    minScore: 70,
    summary: 'Well-qualified candidate in a relevant field.',
    reviewPath: 'Interview within 1 week',
    entryTier: 'Enters as Associate',
    icon: Target,
  },
  {
    id: 'fast-track',
    level: 4,
    name: 'Fast-track',
    minScore: 85,
    summary: 'Exceptional candidate in a high-demand field.',
    reviewPath: 'Priority review within 48 hours',
    entryTier: 'Can enter directly as Fellow',
    icon: Zap,
  },
];
